import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Menu } from '../dropdown';
export const CompactMenu = styled(Menu)`
  font-size: var(--font-size-base);
  border-bottom: none;
  margin-top: calc(-1 * var(--spacing-03));
  margin-left: var(--spacing-01);
  padding-top: var(--spacing-04);
  padding-bottom: 0;
  width: unset;
  &.ant-menu-horizontal {
    overflow-y: clip;
  }
  &.ant-menu.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item,
  & .ant-menu-item {
    min-width: auto;
    padding-right: 0px;
    padding-left: 0px;
    margin: 0px;
    margin-right: var(--spacing-05);
  }
  & .ant-menu-item-only-child,
  .ant-menu-submenu {
    border-bottom: none;
  }
  &.ant-menu.ant-menu-horizontal:not(.ant-menu-dark)
    > .ant-menu-item-only-child:hover {
    color: var(--gray-80);
    border-bottom: 2px solid var(--cool-gray-50);
  }

  &.ant-menu.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected {
    border-bottom: 2px solid var(--blue-60);
    &::after {
      border-bottom: none;
    }
  }
  &.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item:hover::after {
    border-bottom: none;
  }

  &.ant-menu.ant-menu-horizontal:not(.ant-menu-dark)
    > .ant-menu-item-selected:hover {
    border-bottom: 2px solid var(--blue-60);
  }
  & .ant-menu,
  &.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item,
  & .ant-menu.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu {
    border-bottom: none;
  }
  & .ant-badge,
  &.ant-badge-not-a-wrapper {
    margin-right: var(--spacing-02);
  }

  &.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected::after {
    border-bottom: none;
  }

  &.ant-menu-horizontal:not(.ant-menu-dark)
    > .ant-menu-item:not(:hover)::after {
    border-bottom: none !important;
  }
`;
const CompactTitle = styled.span`
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  display: flex;
  align-items: center;
`;
export const TabIcon = styled.div`
  margin-right: var(--spacing-03);
  position: relative;
  top: 3px;
  color: var(--gray-70);
`;
export const CompactMenuTitle = ({ icon, text, label })=>{
    return /*#__PURE__*/ _jsxs(CompactTitle, {
        "data-cy": `tab-${label !== null && label !== void 0 ? label : text}`,
        children: [
            icon != null && /*#__PURE__*/ _jsx(TabIcon, {
                children: icon
            }),
            /*#__PURE__*/ _jsx("span", {
                children: text
            })
        ]
    });
};
